import { useEffect, useState } from 'react';

// Wedding Date: September 19, 2026, 00:00:00 (local).
const TARGET = new Date('2026-09-19T00:00:00').getTime();

// Shared countdown timer. Returns the remaining days/hours/minutes/seconds and
// a `hasStarted` flag (false for the first tick so callers can render nothing
// until the real values are known). Used by every countdown presentation.
export function useCountdown() {
  const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });
  const [hasStarted, setHasStarted] = useState(false);

  useEffect(() => {
    const tick = () => {
      const difference = TARGET - Date.now();
      if (difference <= 0) {
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
        setHasStarted(true);
        return false;
      }
      setTimeLeft({
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
        minutes: Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60)),
        seconds: Math.floor((difference % (1000 * 60)) / 1000),
      });
      setHasStarted(true);
      return true;
    };

    tick();
    const interval = setInterval(() => {
      if (!tick()) clearInterval(interval);
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  return { timeLeft, hasStarted };
}
